import { render, staticRenderFns } from "./FormulaItem.vue?vue&type=template&id=2fdde2c2&scoped=true&"
import script from "./FormulaItem.vue?vue&type=script&lang=js&"
export * from "./FormulaItem.vue?vue&type=script&lang=js&"
import style0 from "./FormulaItem.vue?vue&type=style&index=0&id=2fdde2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdde2c2",
  null
  
)

export default component.exports